import { Component, ElementRef, Input, OnInit, Renderer2, ViewChildren } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { PlantingSiteSpeciesDto } from 'src/app/models/trofaco/plantingSiteSpeciesDto';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { PlantingSiteService } from 'src/app/modules/core/services/planting-site.service';
import { speciesDto } from 'src/app/models/trofaco/speciesDto';
import { FileHandle } from '../../photo-upload/photo-upload.component';
import { TreeSpeciesService } from 'src/app/modules/core/services/tree-species.service';

@Component({
  selector: 'app-modal-add-tree-spicies',
  templateUrl: './add-tree-species.component.html',
  styleUrls: ['./add-tree-species.component.css']
})
export class ModalAddTreeSpeciesComponent implements OnInit {
    @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];
    public isSaved$: Subject<boolean>;
    private _onDestroy$ = new Subject();
    file: FileHandle;
    position = 1;
    newPhoto: File;
    isInvildSelect :boolean = false
    @Input()
    speciesDto : speciesDto[];
    @Input()
    misc: number;
    @Input()
    isEditSpecies:boolean;
    @Input()
    plantingSiteAreaId:string
    @Input()
    treeSpecies: PlantingSiteSpeciesDto = {};
    @Input()
    listSpecies: PlantingSiteSpeciesDto[] = [];
    speciesData : speciesDto;
    photoUrl : string;
    description : string;

  constructor(
    private _renderer2: Renderer2,
    private _bsModalService: BsModalRef,

    private el: ElementRef,
    private plantingSiteService: PlantingSiteService,
    private treeSpeciesService: TreeSpeciesService
    ) { }

  async ngOnInit() {
    this.isSaved$ = new Subject();
    var isEmpty = Object.keys(this.treeSpecies).length;
    if(isEmpty != 0){
        this.speciesData = {
            species: this.treeSpecies.species,
            description: this.treeSpecies.description,
            id : this.treeSpecies.id,
        };
        this.listSpecies.push(this.speciesData);
        const speciesData =  await this.plantingSiteService.getSpeciesById(this.treeSpecies.id);
        this.description = speciesData.description;
        this.photoUrl = speciesData.photoUrl;

    }
  }

  async save() {
    if (this.isInvalidDirectives.some(value => value.isInvalid)) return;
    if (this.isEditSpecies) {
      const result = await this.treeSpeciesService.updateSpeies(this.treeSpecies);
      this.treeSpecies.speciesId = result.id;
    }else {
      const result = await this.treeSpeciesService.createSpeies(this.treeSpecies);
      this.treeSpecies.speciesId = result.id;
    }
    if (this.newPhoto) {
        var resultPhoto = await this.plantingSiteService.updatePlantedTreesPhoto(this.newPhoto, this.treeSpecies.speciesId);

        this.treeSpecies.photoUrl = resultPhoto.data.originalUrl;
    }

    this.isSaved$.next(true);
    this._bsModalService.hide();
  }

  hideNavModal() {
    this._bsModalService.hide();
  }
  
  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
    this.isSaved$.complete();

    const body = document.getElementsByTagName("body")[0];
    this._renderer2.removeClass(body, "modal-open");
  }

  onPhotoSelected(photo: File){
    this.newPhoto = photo;
  }

  async onSelect(species:speciesDto[]){
  if(species.length != 0){
    const speciesData =  await this.plantingSiteService.getSpeciesById(species[0].id);
    this.isInvildSelect = false;
    const ngSelect: HTMLElement = document.getElementsByClassName("ng-select-container")[0] as HTMLElement;
    ngSelect.setAttribute('style', '');

    this.photoUrl =  speciesData.photoUrl;
    this.description = speciesData.description;
    this.treeSpecies.species = speciesData.species;
  }
  else{
      this.photoUrl = null
      this.description = "";
      if(this.newPhoto){
        this.newPhoto = null;
      }
    }
  }

  createNewSpecies = async (name: string): Promise<speciesDto> => {
      this.creatingNew = true;
      let species = await this.plantingSiteService.createSpeies(name);

      this.speciesDto.push(species);
      this.creatingNew = false;
      return {id: species.id, species: species.species};
  }

  creatingNew = false;
  trimAndLower(term: string, species: speciesDto): boolean{
    let pattern = '^' + term.trim().toLowerCase() + '$';
    let matchingRegex = new RegExp(pattern);
    return !!species.species.toLowerCase().match(matchingRegex);
  }
}

